module.exports = __webpack_public_path__ + "static/logo25-5b1bab3a58a47e1af18c6c9b1c9ad245.png";